import { AccordionDetails, Grid } from "@mui/material";
import { Theme, styled } from "@mui/material/styles";
import makeStyles from "@mui/styles/makeStyles";
import createStyles from "@mui/styles/createStyles";
import { colors } from "@zapalacorp/tokens";
import { CSSProperties } from "@mui/styles";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      width: "100%",
      backgroundColor: "#F9FAFB",
      padding: "2rem 0rem 2rem 0rem",
    },
    heading: {
      fontSize: theme.typography.pxToRem(15),
      fontWeight: theme.typography.fontWeightRegular as CSSProperties["fontWeight"],
    },
    container: {
      width: "80%",
      marginTop: "2rem",
    },
    accHeading: {
      fontSize: "22px",
      fontWeight: 700,
    },
    accSubHead: {
      fontSize: "16px",
      fontWeight: 400,
      color: "#475467",
    },
    accNo: {
      border: "1.5px solid black",
      fontSize: "14px",
      fontWeight: 700,
      width: "32px",
      borderRadius: "50%",
      height: "32px",
      padding: "4px",
      textAlign: "center",
      marginRight: "6%",
    },
    accBadge: {
      width: "82px",
      height: "24px",
      backgroundColor: "#FEF3F2",
      color: "#D92D20",
      textAlign: "center",
    },
    accHeadSec: {
      width: "100%",
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
    },
    boxAccNo: {
      display: "flex",
      alignItems: "center",
      height: "100%",
      width: "65%",
    },
    boxAccHeading: {
      height: "100%",
    },
    boxAccBadge: {
      height: "100%",
    },
    headerBreadcrumbs: {
      "& ol": {
        alignItems: "flex-end",
      },
    },
    headerBreadcrumbsTitle: {
      fontSize: 18,
      lineHeight: "24px",
      fontWeight: "bold",
      color: "#1D2939",
      fontFamily: `'Manrope', sans-serif`,
      "&.active": {
        color: "#0055A4",
      },
    },
    userMaintainerHeader: {
      background: "#F8FAFC",
      padding: 15,
      height: 90,
      display: "flex",
      alignItems: "center",
      boxShadow: "inset 0px -1px 0px #F0F0F0",
    },
    businessDetailFormContainer: {
      width: "100%",
      boxSizing: "border-box",
      padding: "15rem",
    },
    accDetails: {
      display: "flex",
      flexDirection: "column",
    },
    formHeading: {
      color: colors.gray600,
      marginBottom: "24px",
      marginTop: "32px",
      fontFamily: "Manrope",
      fontSize: "16px",
      fontWeight: 600,
      lineHeight: "24px",
    },
    accordion: {
      marginTop: "2rem",
      "& .MuiAccordionSummary-content": {
        fontFamily: "Manrope, sans-serif !important",
      },
      "& .MuiAccordionSummary-root": {
        fontFamily: "Manrope, sans-serif !important",
      },
      "& .MuiTypography-root": {
        fontFamily: "Manrope, sans-serif !important",
      },
    },
    checkbox: {
      marginTop: "2%",
    },
    marginTop: {
      marginTop: "3%",
    },
    accMembers: {
      width: "100%",
      height: "100%",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
    },
    splitButton: {
      marginTop: "2rem",
    },
    buttonOptions: {
      width: "100%",
      height: "72px",
      padding: "16px 24px 16px 24px",
      border: "1px solid #E4E7EC",
      borderRadius: "8px",
      margin: "32px 0 40px 0px",
      display: "flex",
      alignItems: "center",
      justifyContent: "flex-end",
      backgroundColor: "#FFFFFF",
    },
  })
);

export const AccordionDetailsWrapper = styled(AccordionDetails)(() => ({
  flexDirection: "column",
}));

export const FieldContainer = styled(Grid)(() => ({
  padding: "0px 0px",
}));

export const BillingAddressContainer = styled(Grid)(() => ({
  display: "flex",
  flexDirection: "column",
}));

export const BillingAddressCheckbox = styled("div")(() => ({
  marginTop: "8px",
}));

export default useStyles;
